import React from 'react';
import { BookOpen, Check, Headphones, Book, Tablet, Trash2 } from 'lucide-react';

const BookCard = ({ book, onDelete }) => {
  // Helper to format duration
  const formatDuration = (minutes) => {
    if (!minutes) return 'Unknown length';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}h ${m}m`;
  };

  // Helper for Format Icon
  const FormatIcon = () => {
    switch (book.format) {
      case 'audio': return <Headphones size={14} />;
      case 'ebook': return <Tablet size={14} />;
      default: return <Book size={14} />;
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Remove "${book.title}" from your library?`)) {
      onDelete(book.id);
    }
  };

  return (
    <div 
      style={{
        width: '140px',
        flexShrink: 0,
        cursor: 'pointer',
        position: 'relative',
        group: 'true' // For hover effects if we had a CSS framework like tailwind
      }}
    >
      {/* Delete Button (Corner) */}
      <button 
        onClick={handleDelete}
        style={{
          position: 'absolute',
          top: '-8px',
          left: '-8px',
          zIndex: 10,
          backgroundColor: 'white',
          border: '1px solid #ff5252',
          borderRadius: '50%',
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ff5252',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          cursor: 'pointer'
        }}
        title="Remove Book"
      >
        <Trash2 size={14} />
      </button>

      {/* Cover Image */}
      <div style={{
        height: '210px',
        width: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: 'var(--bg-card)',
        boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
        position: 'relative',
        border: '1px solid var(--border)'
      }}>
        {book.cover ? (
          <img src={book.cover} alt={book.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: '10px', textAlign: 'center' }}>
            <BookOpen size={32} color="var(--text-soft)" />
            <span style={{ fontSize: '0.7rem', color: 'var(--text-soft)', marginTop: '5px' }}>{book.title}</span>
          </div>
        )}

        {/* Status Badge */}
        {book.status === 'read' && (
          <div style={{
            position: 'absolute', top: '8px', right: '8px',
            backgroundColor: 'rgba(76, 175, 80, 0.9)',
            borderRadius: '50%', padding: '4px',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <Check size={12} color="white" />
          </div>
        )}
      </div>

      {/* Info Below */}
      <div style={{ marginTop: '8px' }}>
        <h3 style={{ 
          fontSize: '0.9rem', margin: '0 0 2px 0', 
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          color: 'var(--text-main)'
        }}>
          {book.title}
        </h3>
        <p style={{ fontSize: '0.8rem', color: 'var(--text-soft)', margin: 0 }}>
          {book.author}
        </p>
        
        {/* Metadata Row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px', color: 'var(--text-soft)', fontSize: '0.75rem' }}>
          <FormatIcon />
          <span>
            {book.format === 'audio' 
              ? formatDuration(book.audio_minutes) 
              : `${book.totalPages || '?'} pgs`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookCard;
